export default __webpack_public_path__ + "99b477b6520ab3f2630c712294225c71.svg";